import { render } from "./JobText.vue?vue&type=template&id=5cf831e0&scoped=true"
import script from "./JobText.vue?vue&type=script&lang=js"
export * from "./JobText.vue?vue&type=script&lang=js"

import "./JobText.vue?vue&type=style&index=0&id=5cf831e0&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf831e0"]])

export default __exports__